// REACT DEFAULTS
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

// COMPONENTS
import InputField from '../../components/InputField'

// STYLES & ASSETS
import styles from './SignIn.module.scss'
import logo from '../../assets/images/bani_logo.png'

const NewTest = () => {
	const navigate = useNavigate()

	const [user, setUser] = useState({
		email: '',
		password: '',
	})

	const handleChange = (e) => {
		setUser((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}))
	}

	const handleLogin = (e) => {
		e.preventDefault()

		const validate = () => {
			if (user) {
				if (
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(user.email) &&
					user.password.length >= 8
				) {
					navigate('/dashboard')

					setUser({
						email: '',
						password: '',
					})
					return true
				} else {
					navigate('/', { replace: true })
					setUser({
						email: '',
						password: '',
					})
					return
				}
			}
			return false
		}
		validate()
	}

	return (
		<div className={styles.formContainer}>
			<div className={styles.logoDiv}>
				<img className={styles.logo} src={logo} alt="logo" />
			</div>

			<form className={styles.signInForm}>
				<h1 className={styles.title}>Log in to your account</h1>
				<p className={styles.subtitle}>
					Don&apos;t have an account?
					<Link to={'#'} className={styles.subtitle_link}>
						{' '}
						Get Started
					</Link>
				</p>

				<InputField
					id={'email'}
					label={'Email'}
					type={'email'}
					placeholder={'E.g: victor.onazi@getbani.co'}
					onChange={handleChange}
					value={user.email}
				/>

				<InputField
					id={'password'}
					label={'Password'}
					linkText={'Forgot password?'}
					type={'password'}
					placeholder={'password'}
					onChange={handleChange}
					value={user.password}
				/>

				<button
					className={styles.btnSubmit}
					type="submit"
					onClick={handleLogin}
				>
					Log in
				</button>
			</form>
		</div>
	)
}

export default NewTest
